import { ControlProps, OptionTypeBase, StylesConfig } from "react-select";
import { CSSObject } from "styled-components";

import { DESKTOP } from "common/constants/breakpoints";

export const styles: StylesConfig<OptionTypeBase, false> = {
  container(provided: CSSObject) {
    return {
      ...provided,
      width: "100%",
    };
  },
  control(provided: CSSObject, state: ControlProps<OptionTypeBase, false>) {
    const {
      selectProps: { menuIsOpen },
    } = state;
    return {
      ...provided,
      width: "100%",
      borderRadius: menuIsOpen ? "8px 8px 0 0" : "8px",
      borderColor: "#474747",
      outline: "none",
      boxShadow: "none",
      transition: "none",
      minHeight: 48,
      "&:hover": {
        borderColor: "#474747",
      },
      [`@media screen and (min-width: ${DESKTOP}px)`]: {
        cursor: "pointer",
      },
    };
  },
  valueContainer(provided: CSSObject) {
    return {
      ...provided,
      paddingLeft: "6px",
    };
  },
  indicatorSeparator() {
    return { display: "none" };
  },
  indicatorsContainer(provided: CSSObject) {
    return {
      ...provided,
    };
  },
  dropdownIndicator() {
    return { display: "none" };
  },
  singleValue(provided: CSSObject) {
    return {
      ...provided,
      color: "#676767",
      fontSize: 14,
      fontWeight: 400,
    };
  },
  placeholder(base: CSSObject) {
    return {
      ...base,
      color: "#a8a8a8",
      fontSize: 14,
      fontWeight: 400,
    };
  },
  menu(provided: CSSObject) {
    return {
      ...provided,
      margin: 0,
      borderRadius: "0 0 8px 8px",
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "#474747",
      borderTop: "none",
      boxShadow: "none",
    };
  },
  menuList(base: CSSObject) {
    return {
      ...base,
      padding: 0,
      borderRadius: "inherit",
    };
  },
  option(base: CSSObject, { isSelected }) {
    return {
      ...base,
      backgroundColor: "#ffffff",
      fontSize: 14,
      fontWeight: isSelected ? 700 : 400,
      color: "#676767",
      "&:hover, &:active": {
        backgroundColor: "#e2e2e2",
      },
      [`@media screen and (min-width: ${DESKTOP}px)`]: {
        cursor: "pointer",
      },
    };
  },
};
